<section>
  <div style="width: 200px; height: 200px; margin: 0 auto; background-color:red">
    <app-emed-barcode></app-emed-barcode>
  </div>
</section>
